import axios from "axios";

// const baseUrl = "https://web.imaxbms.ir/api";
const baseUrl = "https://back.iocenter.ir/api";
// const baseUrl = "http://localhost:8000/api";

axios.defaults.headers.common["Authorization"] =
  "Bearer " + localStorage.getItem("token");

const SendOtp = ({ phone_number = null, email = null } = {}) => {
  const data = {
    ...(phone_number && { phone_number }),
    ...(email && { email }),
  };
  return axios.post(baseUrl + "/auth/send-otp", data);
};

const VerifyOtp = ({ otp_code, phone_number, email } = {}) => {
  const data = {
    otp_code,
    ...(phone_number && { phone_number }),
    ...(email && { email }),
  };
  return axios.post(baseUrl + "/auth/verify-otp", data);
};

const GetNotificationStatus = ({ api_key, token } = {}) => {
  const params = {
    ...(api_key && { api_key }),
  };

  const headers = {
    Authorization: `Bearer ${token}`, // Replace `yourAuthToken` with the actual token
  };

  return axios.get(baseUrl + "/notif-status", { params, headers });
};

// const GetNotificationStatus = ({ api_key } = {}) => {
//   return axios.get("http://s1.imaxbms.com:8000/apps/" + api_key, {
//     headers: {
//       "Content-Type": "application/x-www-form-urlencoded",
//     },
//   });
// };

const UpdateUser = ({ is_admin } = {}) => {
  const data = {
    is_admin,
  };
  return axios.put(baseUrl + "/users/update", data);
};

const UpdateNotifStatus = ({ status } = {}) => {
  const data = {
    status,
  };
  return axios.put(baseUrl + "/update-notif-status", data);
};

const GetDeviceNotifStatus = ({ device_serial, token } = {}) => {
  const params = {
    ...(device_serial && { device_serial }),
  };

  return axios.get(baseUrl + "/device-notif-status", {
    params,
  });
};

const UpdateDeviceNotifyStatus = ({
  device_serial,
  notification_status,
  internet_token,
  notification_names,
  internet_notify_status,
  sms_notify_status,
} = {}) => {
  const data = {
    device_serial,
    notification_status,
    internet_token,
    notification_names,
    internet_notify_status,
    sms_notify_status,
  };
  return axios.put(baseUrl + "/update-device-notif-status", data);
};

const BackupList = () => {
  const data = {};

  return axios.get(baseUrl + "/backups/all", data);
};

const RestoreBackup = ({ index } = {}) => {
  const data = {
    index,
  };
  return axios.post(baseUrl + "/backups/restore", data);
};

const ShareBackup = ({ backup_id, partner } = {}) => {
  const data = {
    backup_id,
    partner,
  };
  return axios.post(baseUrl + "/backups/share", data);
};

const MakeBackup = ({ backup_name, limited } = {}) => {
  const data = {
    backup_name,
    limited,
  };
  return axios.post(baseUrl + "/backups/backup", data);
};

const RemoveBackup = ({ backup_id } = {}) => {
  const data = {
    backup_id,
  };
  return axios.delete(baseUrl + "/backups/delete", { data });
};

const DevicesList = ({ devices_type, fw_version, is_bus } = {}) => {
  const params = {
    ...(devices_type && { devices_type }),
    ...(fw_version && { fw_version }),
    ...(is_bus != null && { is_bus }),
  };

  return axios.get(baseUrl + "/devices/all", { params });
};

const UpdateDevice = ({
  device_id,
  device_name,
  bridge_device_serial,
} = {}) => {
  const data = {
    id: device_id,
    ...(device_name && { name: device_name }),
    ...(bridge_device_serial && { bridge_device_serial }),
  };

  return axios.put(baseUrl + "/devices/update", data);
};

const DeleteDevice = ({ device_id } = {}) => {
  const data = {
    device_id,
  };

  return axios.delete(baseUrl + "/devices/delete", {
    data: data,
  });
};

const ShowDevice = ({ device_id } = {}) => {
  const params = {
    device_id,
  };

  return axios.get(baseUrl + "/devices/show", { params });
};

const CreateRoom = ({ name } = {}) => {
  const data = {
    name,
  };
  return axios.post(baseUrl + "/rooms/create", data);
};

const UpdateRoom = ({ name, room_id } = {}) => {
  const data = {
    name,
    room_id,
  };
  return axios.put(baseUrl + "/rooms/update", data);
};

const AllRoom = ({ user_id = null } = {}) => {
  const params = {
    ...(user_id && { user_id }),
  };
  return axios.get(baseUrl + "/rooms/all", { params });
};

const DeleteRoom = ({ room_id } = {}) => {
  const data = {
    room_id,
  };
  return axios.delete(baseUrl + "/rooms/delete", { data });
};

const CreateEquipments = ({ room_id, type, name } = {}) => {
  const data = {
    room_id,
    type,
    name,
  };
  return axios.post(baseUrl + "/equipments/create", data);
};

const UpdateEquipments = ({ equipment_id, name } = {}) => {
  const data = {
    equipment_id,
    name,
  };
  return axios.put(baseUrl + "/equipments/update", data);
};

const DeleteEquipments = ({ equipment_id } = {}) => {
  const data = {
    equipment_id,
  };
  return axios.delete(baseUrl + "/equipments/delete", { data });
};

const AllEquipments = ({ room_id, user_id } = {}) => {
  const params = {
    ...(room_id && { room_id }),
    ...(user_id && { user_id }),
  };
  return axios.get(baseUrl + "/equipments/all", { params });
};

const ShowEquipment = ({ equipment_id } = {}) => {
  const params = {
    equipment_id,
  };
  return axios.get(baseUrl + "/equipments/show", { params });
};

//Equipment Button

const CreateEquipmentButton = ({
  equipment_id,
  device_id,
  type,
  names,
  digits,
  digit,
  datas,
} = {}) => {
  const data = {
    equipment_id,
    device_id,
    ...(names && { names }),
    ...(type && { type }),
    ...(digit && { digit }),
    digits,
    data: datas,
  };

  return axios.post(baseUrl + "/equipment-buttons/create", data);
};

const UpdateEquipmentButton = ({
  equipment_button_id,
  name = null,
  digit = null,
  icon = null,
  data = null,
  is_continual = 0,
} = {}) => {
  const datas = {
    equipment_button_id,
    ...(name && { name }),
    ...(digit != null && { digit }),
    ...(icon && { icon }),
    ...(data && { data }),
    ...(is_continual != null && { is_continual }),
  };

  return axios.put(baseUrl + "/equipment-buttons/update", datas);
};

const AllEquipmentButton = ({
  equipment_id,
  device_id,
  digit,
  user_id,
} = {}) => {
  const params = {
    user_id,
    ...(equipment_id && { equipment_id }),
    ...(device_id && { device_id }),
    ...(digit && { digit }),
  };

  return axios.get(baseUrl + "/equipment-buttons/all", { params });
};

const ShowEquipmentButton = ({ equipment_button_id } = {}) => {
  const params = {
    ...(equipment_button_id && { equipment_button_id }),
  };

  return axios.get(baseUrl + "/equipment-buttons/show", { params });
};

const DeleteEquipmentButton = ({
  equipment_button_id,
  equipment_buttons_ids = null,
} = {}) => {
  const data = {
    equipment_button_id,
    ...(equipment_buttons_ids && { equipment_buttons_ids }),
  };
  return axios.delete(baseUrl + "/equipment-buttons/delete", { data });
};

const CreateScenario = ({ name, type, repeat } = {}) => {
  const data = {
    ...(name && { name }),
    ...(type && { type }),
    ...(repeat && { repeat }),
  };

  return axios.post(baseUrl + "/scenarios/create", data);
};

const UpdateScenario = ({ scenario_id, name, type, repeat, icon } = {}) => {
  const data = {
    scenario_id,
    type,
    ...(name && { name }),
    ...(repeat && { repeat }),
    ...(icon && { icon }),
  };

  return axios.put(baseUrl + "/scenarios/update", data);
};

const AllScenario = ({} = {}) => {
  const params = {};

  return axios.get(baseUrl + "/scenarios/all", { params });
};

const DeleteScenario = ({ scenario_id } = {}) => {
  const data = {
    scenario_id,
  };
  return axios.delete(baseUrl + "/scenarios/delete", { data });
};

const CreateScenarioCommand = ({
  scenario_id,
  device_id,
  command_name,
  time,
  data,
  icon,
  data1,
  data2,
  data3,
  data4,
  data5,
  data6,
  data7,
  data8,
  data9,
  data10,
  data11,
} = {}) => {
  const datas = {
    scenario_id,
    device_id,
    time,
    ...(command_name && { command_name }),
    ...(icon && { icon }),
    ...(data && { data }),
    ...(data1 != null && { data1 }),
    ...(data2 != null && { data2 }),
    ...(data3 != null && { data3 }),
    ...(data4 != null && { data4 }),
    ...(data5 != null && { data5 }),
    ...(data6 != null && { data6 }),
    ...(data7 != null && { data7 }),
    ...(data8 != null && { data8 }),
    ...(data9 != null && { data9 }),
    ...(data10 != null && { data10 }),
    ...(data11 != null && { data11 }),
  };

  return axios.post(baseUrl + "/scenario-commands/create", datas);
};

const CreateMultipleScenarioCommands = (commands, scenario_id = null) => {
  const datas = {
    commands,
    scenario_id,
  };

  return axios.post(baseUrl + "/scenario-commands/create-cmds", datas);
};

const UpdateScenarioCommand = ({
  scenario_command_id,
  device_id,
  command_name,
  time,
  icon,
  data1,
  data2,
  data3,
  data4,
  data5,
  data6,
  data7,
  data8,
  data9,
  data10,
  data11,
} = {}) => {
  const data = {
    scenario_command_id,
    device_id,
    time,
    ...(command_name && { command_name }),
    ...(icon && { icon }),
    ...(data1 != null && { data1 }),
    ...(data2 != null && { data2 }),
    ...(data3 != null && { data3 }),
    ...(data4 != null && { data4 }),
    ...(data5 != null && { data5 }),
    ...(data6 != null && { data6 }),
    ...(data7 != null && { data7 }),
    ...(data8 != null && { data8 }),
    ...(data9 != null && { data9 }),
    ...(data10 != null && { data10 }),
    ...(data11 != null && { data11 }),
  };

  return axios.put(baseUrl + "/scenario-commands/update", data);
};

const AllScenarioCommand = ({ scenario_id } = {}) => {
  const params = {
    scenario_id,
  };

  return axios.get(baseUrl + "/scenario-commands/all", { params });
};

const DeleteScenarioCommand = ({ scenario_command_id } = {}) => {
  const data = {
    scenario_command_id,
  };
  return axios.delete(baseUrl + "/scenario-commands/delete", { data });
};

const allCharts = ({
  device_id,
  chart_num,
  first_index,
  count,
  start_date,
  end_date,
  bit = null,
  coefficients = null,
}) => {
  const params = {
    device_id,
    chart_num,
    first_index,
    count,
    start_date,
    end_date,
    ...(bit !== null && { bit }),
    ...(coefficients && { coefficients }),
  };

  return axios.get(baseUrl + "/charts/all", { params });
};

const UpdateDeviceOwnerShip = ({ device_id } = {}) => {
  const data = {
    device_id,
  };

  return axios.put(baseUrl + "/update-device-ownership", data);
};

const GetDeviceOwnerShipStatus = ({ device_id } = {}) => {
  const data = {
    device_id,
  };

  return axios.get(baseUrl + "/get-device-ownership-status", { params: data });
};

const RemoveDeviceOwnerShipStatus = ({ device_id } = {}) => {
  const data = {
    device_id,
  };

  return axios.delete(baseUrl + "/remove-device-ownership", { data });
};

const GetCreditStatus = ({ phone_number = null } = {}) => {
  const data = {
    ...(phone_number && { phone_number }),
  };
  return axios.get(baseUrl + "/credit-status", { params: data });
};

const GetCreditStatusUser = ({ } = {}) => {
  return axios.get(baseUrl + "/credit-status-user");
};

const GetCreditStatusPhone = ({ phone_number = null } = {}) => {
  const data = {
    ...(phone_number && { phone_number }),
  };
  return axios.get(baseUrl + "/credit-status-phone", { params: data });
};

const CreatePayment = ({ amount, phone_number, user_id } = {}) => {
  const data = {
    amount,
    phone_number,
    ...(user_id && { user_id }),
  };

  return axios.post(baseUrl + "/payments/create", data);
};

const VerifyPayment = ({ Authority, Status } = {}) => {
  const data = {
    Authority,
    Status,
  };
  return axios.get(baseUrl + "/payments/verify", { params: data });
};

const FetchDevices = ({ str } = {}) => {
  const data = {
    str,
  };
  return axios.get(baseUrl + "/devices/fetch-devices", { params: data });
};

const GetDeviceApiKey = ({ device_id } = {}) => {
  const data = {
    device_id,
  };
  return axios.get(baseUrl + "/devices/api-code", { params: data });
};

const AllHelp = () => {
  return axios.get(baseUrl + "/help/all");
};

const GetUserTransactions = ({ per_page = 20, page = 1 } = {}) => {
  const params = {
    per_page,
    page,
  };
  return axios.get(baseUrl + "/payments/transactions", { params });
};

const ReverifyPayment = ({ payment_id } = {}) => {
  const data = {
    payment_id,
  };
  return axios.post(baseUrl + "/payments/reverify", data);
};

export {
  SendOtp,
  VerifyOtp,
  BackupList,
  RestoreBackup,
  DevicesList,
  ShowDevice,
  DeleteDevice,
  CreateRoom,
  UpdateRoom,
  AllRoom,
  DeleteRoom,
  CreateEquipments,
  UpdateEquipments,
  DeleteEquipments,
  AllEquipments,
  CreateEquipmentButton,
  UpdateEquipmentButton,
  AllEquipmentButton,
  ShowEquipmentButton,
  DeleteEquipmentButton,
  ShowEquipment,
  CreateScenario,
  UpdateScenario,
  AllScenario,
  DeleteScenario,
  CreateScenarioCommand,
  UpdateScenarioCommand,
  AllScenarioCommand,
  DeleteScenarioCommand,
  GetNotificationStatus,
  UpdateNotifStatus,
  GetDeviceNotifStatus,
  UpdateDeviceNotifyStatus,
  UpdateUser,
  UpdateDevice,
  MakeBackup,
  RemoveBackup,
  ShareBackup,
  CreateMultipleScenarioCommands,
  allCharts,
  UpdateDeviceOwnerShip,
  GetDeviceOwnerShipStatus,
  GetCreditStatus,
  CreatePayment,
  VerifyPayment,
  FetchDevices,
  GetDeviceApiKey,
  RemoveDeviceOwnerShipStatus,
  AllHelp,
  GetUserTransactions,
  ReverifyPayment,
  GetCreditStatusUser,
  GetCreditStatusPhone,
};
